import {FormControl} from '@angular/forms';


export function requiredTrim () {

    return function requiredTrimValidate (control: FormControl) {

        if (!control.parent) {
            return null;
        }

        if (!control.value || !control.value.trim()) {
            return {
                required: true
            };
        }

        return null;

    }

}